import React, { FC } from 'react';
import { Spin } from 'antd';
import styled from 'styled-components';
import colors from '~/constants/colors';
import { useGetServicesNavSteps } from '~/controllers/navigation';
import { useDirection } from '~/hooks/i18nHooks';
import ServicesNavStep from './ServicesNavStep';

const ServicesNavigation: any = (props: any) => {
  const { applicationQuery } = props;
  console.log();

  const navStepsQuery = useGetServicesNavSteps();
  const dir = useDirection();
  const newNavStepQuery = navStepsQuery?.data?.map((item: any, index: number, allArr: any) => {
    const IsItVisible =
      applicationQuery?.[item?.uiKey] ||
      // item?.uiKey === 'servicesDetails' ||
      applicationQuery?.[allArr[index - 1]?.uiKey];
    return { ...item, disabled: !IsItVisible };
  });
  return (
    <Container className="ApplicationNavigation" dir={dir}>
      {navStepsQuery.isLoading ? (
        <Spin />
      ) : (
        newNavStepQuery?.map((item, index, arr) => {
          const isLast = index === arr.length - 1;
          return (
            item?.uiKey !== 'selectServices' && (
              <div key={item.stepKey} className="ApplicationNavigation-StepContainer">
                <ServicesNavStep index={index} {...item} />
                {!isLast && <div className="ApplicationNavigation-Divider" />}
              </div>
            )
          );
        })
      )}
    </Container>
  );
};

const Container = styled.div`
  position: sticky;
  top: 66px;
  display: flex;
  flex-direction: column;
  .ApplicationNavigation-StepContainer {
    display: flex;
    flex-direction: column;
    .ApplicationNavigation-Divider {
      display: flex;
      border-left: 1px solid ${colors.borderColorBase};
      height: 8px;
      width: 1px;
      margin: 8px;
    }
  }
`;

export default ServicesNavigation;
